ContactSuccessCtrl = ($scope, $modalInstance, $location) ->

  $scope.cancel = ->
    $modalInstance.dismiss('cancel')
    window.location.reload()

ContactSuccessCtrl.$inject = [
  '$scope'
  '$modalInstance'
  '$location'
]

module.exports = ContactSuccessCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/contact/modals/contact-success-controller.coffee